import React,{useEffect,useState} from "react";

import {
Modal,
Form,
Input,
Select,
Button,
Row,
Col,
message,
Upload
} from "antd";

import api from "../../../api/api";
import {
  UploadOutlined
} from "@ant-design/icons";


const {Option}=Select;


const EditStudentAdmissionPopup=({
visible,
student,
onClose,
refresh
})=>{


const [form]=Form.useForm();

const [loading,setLoading]=useState(false);


const [academicYears,setAcademicYears]=useState([]);
const [grades,setGrades]=useState([]);
const [divisions,setDivisions]=useState([]);
const [superParents,setSuperParents]=useState([]);



const config={
headers:{
Authorization:
`Bearer ${localStorage.getItem("access")}`
}
};



// ================= LOAD DROPDOWNS =================


useEffect(()=>{

loadAcademicYears();
loadGrades();
loadDivisions();
loadSuperParents();

},[]);



const loadAcademicYears=async()=>{

try{

const res=await api.get(
"/academic-years/",
config
);

setAcademicYears(res.data||[]);


}catch(error){

console.log(error);

}

};



const loadGrades=async()=>{

try{

const res=await api.get(
"/api/users/grade-classes/",
config
);

setGrades(res.data||[]);


}catch(error){

console.log(error);

}

};



const loadDivisions=async()=>{

try{

const res=await api.get(
"/api/users/divisions/",
config
);

setDivisions(res.data||[]);


}catch(error){

console.log(error);

}

};



const loadSuperParents=async()=>{

try{

const res=await api.get(
"/api/super-parents/",
config
);

setSuperParents(res.data||[]);


}catch(error){

console.log(error);

}

};







useEffect(() => {
  if (student) {
    form.resetFields();

    form.setFieldsValue({
      full_name: student.full_name,
      gender: student.gender,
      previous_class: student.previous_class,
      grade_class: student.grade_class?.id || student.grade_class,
      division_assigned: student.division_assigned?.id || student.division_assigned,
      major_subject: student.major_subject,
      previous_school: student.previous_school,
      hobit: student.hobit,
      date_of_birth: student.date_of_birth,
      address: student.address,
      mother_name: student.mother_name,
      father_name: student.father_name,
      health_status: student.health_status,
      parent_contact: student.parent_contact,
      enrollment_date: student.enrollment_date,
      semester_status: student.semester_status,
      status: student.status,
      student_status: student.student_status,
      nationality: student.nationality,
      parent_id: student.parent_id?.id || student.parent_id,
      academic_year: student.academic_year?.id || student.academic_year,
      county_of_origin: student.county_of_origin,
      student_admission_image: [],
    });
  }
}, [student, form]);

// ================= UPDATE ================= //

const handleSubmit = async (values) => {
    try {
        setLoading(true);

        const formData = new FormData();

        Object.entries(values).forEach(([key, value]) => {

            if (
                key !== "student_admission_image" &&
                value !== undefined &&
                value !== null
            ) {
                formData.append(
                    key,
                    String(value)
                );
            }

        });

        // ============================================
        // STUDENT IMAGE
        // ============================================

        if (
            values.student_admission_image &&
            values.student_admission_image.length > 0
        ) {
            const imageFile =
                values.student_admission_image[0]
                    .originFileObj;

            if (imageFile) {
                formData.append(
                    "student_admission_image",
                    imageFile
                );
            }
        }

        // ============================================
        // DEBUG PARENT CONTACT
        // ============================================

        console.log(
            "Parent Contact:",
            values.parent_contact
        );

        console.log(
            "Parent Contact Type:",
            typeof values.parent_contact
        );

        // ============================================
        // UPDATE STUDENT
        // ============================================

        await api.put(
            `/api/users/students/${student.id}/`,
            formData,
            {
                headers: {
                    Authorization:
                        `Bearer ${localStorage.getItem("access")}`,
                },
            }
        );

        message.success(
            "Student admission updated successfully"
        );

        refresh();
        onClose();

    } catch (error) {

        console.error(
            "Student Update Error:",
            error
        );

        console.error(
            "Backend Response:",
            error.response?.data
        );

        // ============================================
        // SHOW ACTUAL DJANGO ERROR
        // ============================================

        const responseData =
            error.response?.data;

        if (
            responseData &&
            typeof responseData === "object"
        ) {

            const errorMessages =
                Object.entries(responseData)
                    .map(([field, errors]) => {

                        if (Array.isArray(errors)) {
                            return `${field}: ${errors.join(", ")}`;
                        }

                        return `${field}: ${errors}`;

                    })
                    .join(" | ");

            message.error(
                errorMessages ||
                "Unable to update student"
            );

        } else {

            message.error(
                "Unable to update student"
            );
        }

    } finally {

        setLoading(false);

    }
};





return(


<Modal

open={visible}

title={
`Edit Admission - ${student?.full_name}`
}

onCancel={onClose}

footer={null}

width={800}

>


<div

style={{

maxHeight:"65vh",

overflowY:"auto",

paddingRight:"15px"

}}

>


<Form

form={form}

layout="vertical"

onFinish={handleSubmit}

>


<Row gutter={16}>



<Col span={12}>

<Form.Item

label="Full Name"

name="full_name"

>

<Input/>

</Form.Item>

</Col>



<Col span={12}>

<Form.Item

label="Gender"

name="gender"

>

<Select>

<Option value="Male">
Male
</Option>

<Option value="Female">
Female
</Option>

</Select>

</Form.Item>

</Col>





<Col span={12}>

<Form.Item

label="Academic Year"

name="academic_year"

>

<Select

showSearch

optionFilterProp="children"

placeholder="Select Academic Year"

>


{
academicYears.map(year=>

<Option

key={year.id}

value={year.id}

>

{year.name}

</Option>

)

}


</Select>

</Form.Item>

</Col>





<Col span={12}>

<Form.Item

label="Grade Class"

name="grade_class"

>

<Select

showSearch

optionFilterProp="children"

placeholder="Select Grade Class"

>


{
grades.map(item=>

<Option

key={item.id}

value={item.id}

>

{item.name}

</Option>

)

}


</Select>


</Form.Item>

</Col>






<Col span={12}>

<Form.Item

label="Division"

name="division_assigned"

>


<Select

placeholder="Select Division"

>


{
divisions.map(item=>

<Option

key={item.id}

value={item.id}

>

{item.name}

</Option>

)

}


</Select>


</Form.Item>


</Col>






<Col span={12}>

<Form.Item

label="Parent"

name="parent_id"

>


<Select

showSearch

optionFilterProp="children"

placeholder="Select Parent"

>


{
superParents.map(parent=>

<Option

key={parent.id}

value={parent.id}

>


{
parent.username ||

parent.full_name ||

parent.email
}


</Option>

)

}


</Select>


</Form.Item>


</Col>





<Col span={12}>

<Form.Item

label="Previous Class"

name="previous_class"

>

<Input/>

</Form.Item>

</Col>



<Col span={12}>

<Form.Item

label="Major Subject"

name="major_subject"

>

<Input/>

</Form.Item>

</Col>



<Col span={12}>

<Form.Item

label="Previous School"

name="previous_school"

>

<Input/>

</Form.Item>

</Col>



<Col span={12}>

<Form.Item

label="Hobby"

name="hobit"

>

<Input/>

</Form.Item>

</Col>



<Col span={12}>

<Form.Item

label="Date of Birth"

name="date_of_birth"

>

<Input type="date"/>

</Form.Item>

</Col>



<Col span={12}>

<Form.Item

label="Enrollment Date"

name="enrollment_date"

>

<Input type="date"/>

</Form.Item>

</Col>



<Col span={12}>

<Form.Item

label="Semester Status"

name="semester_status"

>

<Select>

<Option value="First">
First Semester
</Option>


<Option value="Second">
Second Semester
</Option>


</Select>

</Form.Item>

</Col>





<Col span={12}>

<Form.Item

label="Student Status"

name="student_status"

>

<Select>

<Option value="Regular">
 Regular
</Option>


<Option value="Ward">
Dependent
</Option>


<Option value="Scholarship Student">
Scholarship Student
</Option>


</Select>

</Form.Item>

</Col>





<Col span={12}>

<Form.Item

label="Status"

name="status"

>

<Select>

<Option value="Pending">
Pending
</Option>


<Option value="Enrolled">
Enrolled
</Option>


<Option value="Graduated">
Graduated
</Option>


<Option value="Dropped">
Dropped
</Option>


</Select>


</Form.Item>


</Col>





<Col span={12}>

<Form.Item

label="Nationality"

name="nationality"

>

<Input/>

</Form.Item>

</Col>





<Col span={12}>

<Form.Item

label="County Of Origin"

name="county_of_origin"

>

<Input/>

</Form.Item>

</Col>





<Col span={12}>

<Form.Item

label="Father Name"

name="father_name"

>

<Input/>

</Form.Item>

</Col>





<Col span={12}>

<Form.Item

label="Mother Name"

name="mother_name"

>

<Input/>

</Form.Item>

</Col>





<Col span={12}>
    <Form.Item
        label="Parent Contact"
        name="parent_contact"
    >
        <Input
            placeholder="07734554345/07734453355"
            maxLength={50}
        />
    </Form.Item>
</Col>





<Col span={12}>

<Form.Item

label="Health Status"

name="health_status"

>

<Input/>

</Form.Item>

</Col>


<Col span={12}>

<Form.Item
  label="Student Admission Image"
  name="student_admission_image"
  valuePropName="fileList"
  getValueFromEvent={(e) =>
    Array.isArray(e)
      ? e
      : e?.fileList
  }
>

<Upload
  beforeUpload={() => false}
  maxCount={1}
  accept="image/*"
>

<Button
  icon={<UploadOutlined />}
>

Select Student Image

</Button>

</Upload>

</Form.Item>

</Col>





<Col span={24}>

<Form.Item

label="Address"

name="address"

>

<Input.TextArea rows={3}/>

</Form.Item>

</Col>



</Row>





<Button

type="primary"

htmlType="submit"

loading={loading}

block

>

Update Student Admission

</Button>




</Form>


</div>


</Modal>


);


};


export default EditStudentAdmissionPopup;